import React from 'react';

import {
  Content,
  CtaButton,
  Header,
  ImageOverlay,
  ImageWrapper,
  StyledImage,
  Subtitle,
  Title,
  Wrapper,
} from './Card.styles';

const Card = ({ image, title, subtitle, linkTitle, ctaUrl }) => (
  <Wrapper>
    <ImageWrapper>
      <StyledImage image={image} />
      <ImageOverlay />
    </ImageWrapper>
    <Content>
      <Header>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
        <Title>{title}</Title>
      </Header>
      {linkTitle && ctaUrl && (
        <CtaButton href={ctaUrl.url} type={ctaUrl.type} color="white" size="half">
          {linkTitle}
        </CtaButton>
      )}
    </Content>
  </Wrapper>
);

export default Card;
